module.exports = __webpack_public_path__ + "img/necromunda-map-main-lables.06829db0.png";